const keyFor = userId => `numerathum:welcome:pending:${userId}`;
// Preferencia permanente "No volver a mostrar" (localStorage: sobrevive a cerrar sesión)
const hiddenKeyFor = userId => `numerathum:welcome:hidden:${userId}`;

export function markWelcomePending(userId, storage = globalThis.sessionStorage) {
  if (!userId) return;
  try { storage?.setItem(keyFor(userId), 'true'); } catch { /* Login must work without storage. */ }
}

export function isWelcomeHidden(userId, persistent = globalThis.localStorage) {
  if (!userId) return false;
  try { return persistent?.getItem(hiddenKeyFor(userId)) === 'true'; } catch { return false; }
}

export function shouldShowWelcome(userId, storage = globalThis.sessionStorage, persistent = globalThis.localStorage) {
  if (!userId || isWelcomeHidden(userId, persistent)) return false;
  try { return storage ? storage.getItem(keyFor(userId)) === 'true' : true; } catch { return true; }
}

export function dismissWelcome(userId, storage = globalThis.sessionStorage) {
  if (!userId) return;
  try { storage?.removeItem(keyFor(userId)); } catch { /* The modal can still close. */ }
}

export function setWelcomeHidden(userId, hidden, persistent = globalThis.localStorage) {
  if (!userId) return;
  try {
    if (hidden) persistent?.setItem(hiddenKeyFor(userId), 'true');
    else persistent?.removeItem(hiddenKeyFor(userId));
  } catch { /* The modal can still close. */ }
}
